import {
  ChromeData,
  fetchChromeData,
  ForbiddenError,
} from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

export default async (): Promise<ChromeData> => {
  try {
    // `await` is load-bearing: returning the promise un-awaited lets a
    // rejection bypass this catch, so the 403 redirect never runs.
    if (window.AACChrome?.InternalAPI) {
      return await window.AACChrome.InternalAPI.ChromedDataHandler.getInstance().getChromeData(
        ChromeInternalApiRequestConfig,
      );
    }
    return await fetchChromeData(ChromeInternalApiRequestConfig);
  } catch (error: any) {
    // BTAS answers an unauthenticated chromeData request with 403 and
    // `{ url: <sign-out URL> }`; send the user there to sign in again. Skip it
    // when no URL came back rather than navigating to "/undefined".
    if (
      window &&
      error &&
      error.type === ForbiddenError.TYPE &&
      typeof error.loginUrl === 'string' &&
      error.loginUrl
    ) {
      window.location.replace(error.loginUrl);
    }
    throw error;
  }
};
